import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UpdateBrokerKey from "./Update_Broker_Key";
import Loginwihapi from "./log_with_api";
import * as Config from "../../Utils/Config";
import axios from "axios";
import {
  addChartingScript,
  getChargingPlatformDataApi,
  TradingStatus,
} from "../CommonAPI/User";

import Swal from "sweetalert2";
import { Wallet, ChevronUp, ChevronDown, SunMoon } from "lucide-react";
import {
  LastPattern,
  DataStart,
  AutoLogin,
  DataStartget,
  AutoLoginget,
  GetIndexData,
} from "../CommonAPI/Admin";
import { addBroker } from "../CommonAPI/SuperAdmin";
import { jwtDecode } from "jwt-decode";
import { Get_Profile_Data } from "../CommonAPI/User";
import { useTheme } from "../../ThemeContext";
import { connectWebSocket } from "../user/UserDashboard/LivePrice";
import $ from "jquery";
import ApiProcessModal from "./ApiProcessModal";
import Chatbot from "./Chatbot";
import DynamicModal from "../../ExtraComponent/DynamicModal";
import { toast } from "react-toastify";

const Header = ({ permissionData }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    document.body.classList.toggle("sidebar-open"); // body par class toggle
  };
  const [selectedImage, setSelectedImage] = useState(
    localStorage.getItem("userProfileImage") ||
      "https://cdn-icons-png.flaticon.com/512/8847/8847419.png"
  );

  const navigate = useNavigate();
  const role = localStorage.getItem("Role");
  const Username = localStorage.getItem("name");
  const token = localStorage.getItem("token");
  const [isActive, setIsActive] = useState(true);
  const [activeElement, setActiveElement] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [getTradingStatus, setTradingStatus] = useState(false);

  const [getBrokerName, setBrokerName] = useState("");
  const [showAddBrokerModal, setShowAddBrokerModal] = useState(false);
  const [addBrokerName, setAddBrokerName] = useState("");


  const [autoLoginLoading, setAutoLoginLoading] = useState(false);
  const [dataStartloading, setDataStartLoading] = useState(false);
  const [lastPatternloading, setLastPatternLoading] = useState(false);

  const [showApiStepsModal, setShowApiStepsModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    fund: "",
    lot: "",
  });
  const [activeTab, setActiveTab] = useState("Cash");
  const [chartingSegments, setChartingSegments] = useState([]);
  const [baseValue, setBaseValue] = useState(0);
  const [multiplier, setMultiplier] = useState(1);
  const [isAutoLogin, setIsAutoLogin] = useState(false);
  const [isDataStart, setIsDataStart] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const prevInputValueRef = useRef(0);

  const location = useLocation();
  const Broker = localStorage.getItem("Broker");

  const niftyRef = useRef(null);
  const bankNiftyRef = useRef(null);

  const handleBroker = async () => {
    setShowApiStepsModal(true);
  };

  const getChartingData = async () => {
    try {
      const res = await getChargingPlatformDataApi("Admin");
      let updatedFormData = {
        fund: "",
        lot: "",
      };
      res.Client.forEach((item) => {
        if (item.Segment === activeTab) {
          if (activeTab === "Cash") {
            updatedFormData.fund = item.Fund;
            setBaseValue(item.Fund);
          } else {
            updatedFormData.lot = item.Quantity;
            setBaseValue(item.Quantity);
          }
        }
      });
      setFormData(updatedFormData);
    } catch (err) {
      console.error("Error in getting the charting data", err);
    }
  };

  useEffect(() => {
    getprofiledata();
    GetindexdataApi();
  }, []);

  useEffect(() => {
    getChartingData();
  }, [open, activeTab]);

  useEffect(() => {
    fetchDataStartget();
    fetchAutoLoginget();
  }, []);

  useEffect(() => {
    if (activeTab === "Cash") {
      setFormData({ fund: baseValue * multiplier, lot: 0 });
    } else {
      setFormData({ lot: baseValue * multiplier, fund: 0 });
    }
  }, [baseValue, multiplier, activeTab]);

  useEffect(() => {
    fetchChartingSegments();
  }, []);

  useEffect(() => {
    if (activeTab === "Cash") {
      setFormData({ fund: baseValue * multiplier, lot: 0 });
    } else {
      setFormData({ lot: baseValue * multiplier, fund: 0 });
    }
  }, [baseValue, multiplier, activeTab]);

  useEffect(() => {
    setMultiplier(1);
  }, [activeTab]);

  useEffect(() => {
    const name = localStorage.getItem("name");
    const expireClient = localStorage.getItem("expire");

    if (role === "User" && expireClient === "1") {
      if (location.pathname === "/user/all/transection") {
        navigate("/user/all/transection", { replace: true }); // Allow transection page
      } else {
        navigate("/user/all/plan", { replace: true }); // Redirect to plan page for all other URLs
      }
    }
  }, [navigate]);

  useEffect(() => {
    clearSession();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".search-toggle") &&
        !event.target.classList.contains("search-input")
      ) {
        setActiveElement(null);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isActive) {
      document.body.classList.add("sidebar-main");
    } else {
      document.body.classList.remove("sidebar-main");
    }
  }, [isActive]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchChartingSegments = async () => {
    try {
      const response = await getChargingPlatformDataApi(Username);
      if (response) {
        setChartingSegments(response.Client.map((item) => item.Segment) || []);
      } else {
        setChartingSegments([]);
      }
    } catch (error) {
      console.error("Error fetching charting segments:", error);
    }
  };

  const fetchDataStartget = async () => {
    try {
      if (role === "Admin") {
        const response = await DataStartget();
        setIsDataStart(response?.Status);
      }
    } catch (error) {
      console.error("Error fetching data start:", error);
    }
  };

  const fetchAutoLoginget = async () => {
    try {
      if (role === "Admin") {
        const response = await AutoLoginget();
        setIsAutoLogin(response?.Status);
      }
    } catch (error) {
      console.error("Error fetching auto login data:", error);
    }
  };

  const handleChange = (e) => {
    const val = parseFloat(e.target.value) || 0;
    setBaseValue(val); // ✅ This is important
    setMultiplier(1); // Reset multiplier on manual change
  };

  const handleUp = (e) => {
    const val = parseFloat(e.target.value) || 0;
    setMultiplier((m) => m + 1);
  };

  const handleDown = () => {
    setMultiplier((m) => (m > 1 ? m - 1 : 1));
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setBaseValue(0);
    setMultiplier(1);
    setFormData({ fund: "", lot: "" });
    prevInputValueRef.current = 0;
    setOpen(false);
  };

  const handleTypeAction = async () => {
    const req = {
      Username: "Admin",
      Status: "On",
      Fund: activeTab === "Cash" ? formData.fund : 0,
      Lot: activeTab !== "Cash" ? formData.lot : 0,
      Segment: activeTab,
      TradeCount: 1000000,
      RunningTrade: 1000000,
      MaxProfit: 0,
      MaxLoss: 0,
      ExitDay: "Intraday",
      ASStatus: "On",
      Strategytag: [""],
    };

    try {
      let response = await addChartingScript(req);
      if (response?.Status) {
        toast.success(response.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        await getChartingData();
      } else {
        toast.error(response.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      setMultiplier(1); // Reset multiplier to 1 after successful submission
    } catch (err) {
      console.error("Error in adding the charting data", err);
    }
  };

  const handleToggle = async (value) => {
    // Prevent toggling to the same state
    if (value === getTradingStatus) {
      return; // Exit early if user clicks the currently active mode
    }

    const newStatus = value;

    if (newStatus == true) {
      const requestData = {
        Username: Username,
        session: "",
        AccToken: "",
        usrid: "",
        sid: "",
        jwt_Token: "",
        BrokerName: getBrokerName,
      };
      Loginwihapi(requestData);
    } else {
      var data = {
        Username: Username,
        session: "",
        AccToken: "",
        usrid: "",
        sid: "",
        jwt_Token: "",
      };

      try {
        const response = await axios.post(
          `${Config.base_url}ConnectBroker`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("ConnectBroker response:", response.data);
        if (response.data.Status) {
          // Assuming the status is in response.data.Status
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Success!",
            text: "Trading On successfully.",
            icon: "success",
            confirmButtonText: "OK",
            timer: 1000,
          }).then(() => {
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          });
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Success!",
            text: "Trading Off successfully.",
            icon: "success",
            confirmButtonText: "OK",
            timer: 1000,
          }).then(() => {});
        }
      } catch (err) {
        console.error("Error in ConnectBroker request", err);
        Swal.fire({
          // background: "#1a1e23 ",
          backdrop: "#121010ba",
          confirmButtonColor: "#1ccc8a",
          title: "Error!",
          text: "An error occurred. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const handleChatToggle = () => {
    setShowChat(!showChat);
  };

  const handleClick = (event, id) => {
    event.preventDefault();

    if (activeElement === id) {
      setActiveElement(null);
    } else {
      setActiveElement(id);
    }
  };

  const logout = async () => {
    localStorage.clear();
    navigate("/login");
  };

  const clearSession = () => {
    var decoded = jwtDecode(token);
    if (decoded.exp * 1000 < new Date().getTime()) {
      localStorage.clear();
      window.location.reload();
    }
  };

  const fetchData = async () => {
    if (role == "User") {
      const requestData = { userName: Username };
      const response = await TradingStatus(requestData);

      if (response) {
        setBrokerName(response.Brokername);
        if (response.Status) {
          setTradingStatus(true);
        }
      }
    }
  };

  const handleAutoLoginbtn = async () => {
    setAutoLoginLoading(true); // Loader start
    try {
      let confirmResult;
      if (isAutoLogin) {
        confirmResult = await Swal.fire({
          background: "#1a1e23",
          backdrop: "#121010ba",
          title: "Start Data?",
          text: "Already running, Do you want to proceed anyway?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#1ccc8a",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        });
      }

      if (!confirmResult.isConfirmed) {
        setAutoLoginLoading(false);
        return;
      }

      const response = await AutoLogin();
      Swal.fire({
        background: "#1a1e23",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: response.Status ? "Auto Login On!" : "Error!",
        text: response.message,
        icon: response.Status ? "success" : "error",
        timer: 1500,
        timerProgressBar: true,
      });
    } catch (error) {
      Swal.fire({
        background: "#1a1e23",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
      fetchAutoLoginget();
    } finally {
      setAutoLoginLoading(false); // Loader stop
    }
  };

  const handleDataStart = async () => {
    setDataStartLoading(true);

    try {
      let confirmResult;
      if (isDataStart) {
        confirmResult = await Swal.fire({
          background: "#1a1e23",
          backdrop: "#121010ba",
          title: "Start Data?",
          text: "Already running, Do you want to proceed anyway?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#1ccc8a",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        });

        if (!confirmResult.isConfirmed) {
          setDataStartLoading(false);
          return;
        }
      }

      const response = await DataStart(); // API call

      Swal.fire({
        background: "#1a1e23",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: response.Status ? "Data Started!" : "Error!",
        text: response.message,
        icon: response.Status ? "success" : "error",
        timer: 1500,
        timerProgressBar: true,
      });
    } catch (error) {
      Swal.fire({
        background: "#1a1e23",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
    } finally {
      setDataStartLoading(false);
      fetchDataStartget();
    }
  };

  const handleLastPattern = async () => {
    setLastPatternLoading(true);
    try {
      const response = await LastPattern(); // API call
      Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Last Pattern On !",
        text: response.message,
        icon: "success",
        timer: 1500,
        timerProgressBar: true,
      });
    } catch (error) {
      Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error !",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
    } finally {
      setLastPatternLoading(false); // Loader stop
    }
  };

  const handleSetApiKey = async (e) => {
    e.preventDefault();
    const broker = localStorage.getItem("Broker");
    if (broker == "DEMO") {
      return Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Warning!",
        text: "You are using a demo account. You Can't set API key.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }

    setIsModalVisible(true);
  };

  const handleAddBroker = async () => {
    const req = { BrokerName: addBrokerName };

    if (addBrokerName == "") {
      Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Warning!",
        text: "Please enter Broker Name.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    await addBroker(req)
      .then((response) => {
        if (response.Status) {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Success!",
            text: "Broker Added successfully.",
            icon: "success",
            confirmButtonText: "OK",
            timer: 1000,
          });
          setAddBrokerName("");
          setShowAddBrokerModal(false);
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error!",
            text: response.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        console.error("Error in GetUserBalence request", error);
      });
  };

  const getprofiledata = async () => {
    if (role != "User") {
      return;
    }
    const data = {
      username: Username,
    };
    await Get_Profile_Data(data).then((response) => {
      if (response.Status) {
        localStorage.setItem("expire", 0);
        localStorage.setItem("Broker", response.Data[0].BrokerName);
        localStorage.setItem("Permission", response.Data[0].Permission || "[]");
      } else {
        if (response.message === "Client Expired") {
          localStorage.setItem("expire", 1);
          navigate("/user/all/plan");
        }
      }
    });
  };

  const GetindexdataApi = async () => {
    try {
      let currentWebSocket = null;
      let tokenMap = {}; // use let instead of const

      const response = await GetIndexData();

      // if (response.Status) {
      // reset mapping each time
      tokenMap = {};
      const channels = [];

      if (response.FiniftyToken?.[0]) {
        channels.push(`NFO|${response.FiniftyToken[0]}`);
        tokenMap[response.FiniftyToken[0]] = "FINNIFTY";
      }

      if (response.BankniftyToken?.[0]) {
        channels.push(`NFO|${response.BankniftyToken[0]}`);
        tokenMap[response.BankniftyToken[0]] = "BANKNIFTY";
      }

      if (response.NiftyToken?.[0]) {
        channels.push(`NFO|${response.NiftyToken[0]}`);
        tokenMap[response.NiftyToken[0]] = "NIFTY";
      }

      // Purana WebSocket close kar do
      if (currentWebSocket && typeof currentWebSocket.close === "function") {
        currentWebSocket.close();
      }

      connectWebSocket(
        { userId: response?.Userid, sessionId: response?.Access_Token || "" },
        channels,
        (data) => {
          if (data.lp && data.tk) {
            const indexName = tokenMap[data.tk];
            if (indexName) {
              $(`.LivePrice_${indexName}`).html(data.lp);
            }
          }
        }
      );
    } catch (err) {
      console.log("Error in fetching Index Data", err);
    }
  };

  return (
    <>
      <button className="botIcon" onClick={handleChatToggle}>
        <i className="fa fa-commenting fs-5" aria-hidden="true" />
      </button>
      {showChat && <Chatbot onClose={() => setShowChat(false)} />}

      <div className="iq-top-navbar ">
        <div className="iq-navbar-custom">
          {/* <div className="iq-sidebar-logo">
            <img
              className="header_img2 header-logo-img"
              alt="Logo"
              id="header_img2"
              src={localStorage.getItem("logo")}
            />
          </div> */}

          {/* Conditionally render chatbot */}

          <nav className="navbar navbar-expand-lg navbar-light pb-3 justify-content-between">
            <div className="d-flex align-items-center">
              <button
                className="me-1 menusidebar navbar-toggler ms-2 collapsed"
                onClick={toggleSidebar}
              >
                <i className="ri-menu-3-line" />
              </button>
              <button
                className="navbar-toggler ms-1"
                type="button"
                data-bs-toggle="collapse"
                href="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="ri-more-fill" />
              </button>
              {role === "Superadmin" && (
                <div className="">
                  <div className="">
                    {/* 🔽 THEME SELECTOR DROPDOWN FOR SUPERADMIN */}
                    <div className="ps-3 ">
                      <label className="text-muted fw-bold d-block ">
                        Select Theme:
                      </label>
                      <select
                        className="form-select"
                        onChange={(e) => {
                          const theme = e.target.value;

                          // 🔹 Set or remove data-theme attribute
                          if (theme) {
                            document.body.setAttribute("data-theme", theme);
                          } else {
                            document.body.removeAttribute("data-theme"); // default case
                          }
                        }}
                      >
                        <option value="default">Default</option>
                        <option value="Light">Light Theme</option>
                        <option value="dark">Dark Theme</option>
                        <option value="Mint">Mint</option>
                        <option value="Sapphire-Gradient">
                          Sapphire-Gradient
                        </option>
                        <option value="Terra-Stone">Terra-Stone</option>
                        <option value="Peach-Bloom">Peach-Bloom</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {role === "User" && (
                <div
                  className="btn-group paper-live-trading-btn ms-2 ms-lg-4"
                  role="group"
                  style={{
                    position: "relative",
                    borderRadius: "25px",
                    background: "transparent",
                    padding: "3px",
                    width: "210px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "inset 0 0 6px rgba(255,255,255,0.1)",
                    overflow: "hidden",
                  }}
                >
                  {/* Sliding highlight background */}
                  <div
                    style={{
                      position: "absolute",
                      top: "3px",
                      bottom: "3px",
                      left: getTradingStatus ? "calc(50% + 2px)" : "3px",
                      width: "calc(50% - 5px)",
                      borderRadius: "20px",
                      background: getTradingStatus
                        ? "linear-gradient(90deg, #7367f0, #9e95f5)"
                        : "linear-gradient(90deg, #4caf50, #81c784)",
                      transition: "all 0.35s ease",
                      zIndex: 1,
                    }}
                  ></div>

                  {/* Paper Trading */}
                  <button
                    type="button"
                    onClick={() => handleToggle(false)}
                    style={{
                      flex: 1,
                      fontWeight: 600,
                      fontSize: "12px",
                      padding: "6px 0",
                      border: "none",
                      borderRadius: "20px",
                      background: "transparent",
                      color: !getTradingStatus ? "#fff" : "#aaa",
                      transition: "all 0.3s ease",
                      zIndex: 2,
                      cursor: "pointer",
                    }}
                  >
                    Paper Trading
                  </button>

                  {/* Live Trading */}
                  <button
                    type="button"
                    onClick={() => handleToggle(true)}
                    style={{
                      flex: 1,
                      fontWeight: 600,
                      fontSize: "12px",
                      padding: "6px 0",
                      border: "none",
                      borderRadius: "20px",
                      background: "transparent",
                      color: getTradingStatus ? "#fff" : "#aaa",
                      transition: "all 0.3s ease",
                      zIndex: 2,
                      cursor: "pointer",
                    }}
                  >
                    Live Trading
                  </button>
                </div>
              )}
            </div>

            <div className="d-flex  white-space-nowrap">
              {role === "User" && (
                <>
                  {getBrokerName && getBrokerName == "Demo" && (
                    <li className="nav-item">
                      <button type="button" className="addbtn btn  btn1">
                        Demo Account
                      </button>
                    </li>
                  )}

                  <ul className="nav-item d-lg-flex d-none align-items-center mb-0 ms-3 live-price-ul">
                    <li className="live-price-item ">
                      <div className="live-price-box">
                        <span className="label card-text-Color">NIFTY:</span>
                        <span
                          className="LivePrice_NIFTY liveprice-text-color ms-1"
                          ref={niftyRef}
                        >
                          {}
                        </span>
                      </div>
                    </li>
                    <li className="live-price-item ">
                      <div className="live-price-box">
                        <span className="label card-text-Color">
                          BANKNIFTY:
                        </span>
                        <span
                          className="LivePrice_BANKNIFTY liveprice-text-color ms-1"
                          ref={bankNiftyRef}
                        >
                          {}
                        </span>
                      </div>
                    </li>

                    <li className="live-price-item">
                      <div className="live-price-box">
                        <span className="label card-text-Color">FINNIFTY:</span>
                        <span className="LivePrice_FINNIFTY liveprice-text-color ms-1">
                          {}
                        </span>
                      </div>
                    </li>
                  </ul>
                </>
              )}
              <ul className="navbar-nav ms-auto navbar-list align-items-center d-flex">
                <li className="d-none d-lg-block">
                  {role === "Admin" && (
                    <div className="d-flex justify-content-end align-items-center  btn-width">
                      <button
                        className={`w-100 py-1  shadow-sm btn btn-sm m-2  ${
                          isAutoLogin
                            ? "btn-outline-success"
                            : "btn-outline-danger"
                        }`}
                        onClick={handleAutoLoginbtn}
                        disabled={autoLoginLoading}
                      >
                        {autoLoginLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <strong className="" style={{ fontSize: "0.9rem" }}>
                              Auto Login
                            </strong>
                          </>
                        )}
                      </button>

                      <button
                        className={`w-100 py-1  shadow-sm btn btn-sm m-2  ${
                          isDataStart
                            ? "btn-outline-success"
                            : "btn-outline-danger"
                        }`}
                        onClick={handleDataStart}
                        disabled={dataStartloading}
                      >
                        {dataStartloading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <strong className="" style={{ fontSize: "0.9rem" }}>
                              Data Start
                            </strong>
                          </>
                        )}
                      </button>

                      <div
                        className="nav-item ms-1 btn-text-color"
                        onClick={() => {
                          navigate("/admin/clientactivity");
                        }}
                      >
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="addbtn btn mt-0 btn1 "
                        >
                          <span className="btn-text-color">
                            <span>
                              <Wallet className="iconcol" />
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </li>
                <li
                  className={`nav-item ${
                    activeElement === "profile" ? "iq-show" : ""
                  }`}
                  style={{ listStyleType: "none" }}
                >
                  <a
                    href="#"
                    className={`text-decoration-none search-toggle d-flex align-items-center iq-waves-effectt ${
                      activeElement === "profile" ? "active" : ""
                    }`}
                    onClick={(e) => handleClick(e, "profile")}
                  >
                    <img
                      src={selectedImage || "/assets/images/user/demo.jpg"}
                      className="img-fluid rounded-circle me-2 border border-2 border-primary"
                      alt="user"
                      style={{
                        width: "35px",
                        height: "35px",
                        objectFit: "cover",
                      }}
                    />
                    <div className="caption text-start">
                      <h6 className="mb-0 fw-semibold card-text-Color">
                        {Username}
                      </h6>
                    </div>
                  </a>

                  {role != "User" && (
                    <div className="iq-sub-dropdown iq-user-dropdown">
                      <div className="card shadow border-0">
                        <div className="card-body p-0">
                          <div className="bg-primary p-3 rounded-top">
                            <h5 className="text-white mb-0 card-text-Color">
                              {Username}
                            </h5>
                          </div>

                          {/* Menu Items */}
                          <div
                            className="list-group list-group-flush ps-2"
                            style={{
                              maxHeight: "400px", // fixed height (adjust as needed)
                              overflowY: "auto", // vertical scrollbar
                              overflowX: "hidden", // hide horizontal overflow
                            }}
                          >
                            {role === "Admin" && (
                              <>
                                <button
                                  className="list-group-item list-group-item-action  my-2 card-bg-color"
                                  onClick={() =>
                                    Broker == "BAJAJ"
                                      ? ""
                                      : setIsModalVisible(true)
                                  }
                                >
                                  🔐{" "}
                                  <span className="ms-2 card-text-Color">
                                    Set API Key
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() => setShowModal(true)}
                                >
                                  🔑{" "}
                                  <span className="ms-2 card-text-Color">
                                    Auto Login
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() =>
                                    role === "Admin"
                                      ? navigate("/admin/transectionrequest")
                                      : navigate(
                                          "/subadmin/transaction-history"
                                        )
                                  }
                                >
                                  💵{" "}
                                  <span className="ms-2 card-text-Color">
                                    Transaction Requests
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() => navigate("/admin/Coupon")}
                                >
                                  🎟️{" "}
                                  <span className="ms-2 card-text-Color">
                                    Coupons
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() => navigate("/admin/ResponseQnA")}
                                >
                                  📬{" "}
                                  <span className="ms-2 card-text-Color">
                                    Respond to Queries
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() =>
                                    navigate("/admin/Master-Account")
                                  }
                                >
                                  👑{" "}
                                  <span className="ms-2 card-text-Color">
                                    Master Account
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() => setOpen(true)}
                                >
                                  📡{" "}
                                  <span className="ms-2 card-text-Color">
                                    Admin Signal
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() =>
                                    navigate("/admin/clientreport")
                                  }
                                >
                                  📑{" "}
                                  <span className="ms-2 card-text-Color">
                                    Client Thread Report
                                  </span>
                                </button>

                                <button
                                  className="list-group-item list-group-item-action  card-bg-color my-1"
                                  onClick={() => navigate("/admin/smtp")}
                                >
                                  ⚙️{" "}
                                  <span className="ms-2 card-text-Color">
                                    System & SMTP Details
                                  </span>
                                </button>
                              </>
                            )}
                            <button
                              className="list-group-item list-group-item-action  card-bg-color my-1"
                              onClick={() =>
                                role == "Admin"
                                  ? navigate("/admin/servicereport")
                                  : navigate("/subadmin/servicereport")
                              }
                            >
                              🛠️{" "}
                              <span className="ms-2 card-text-Color">
                                Service Report
                              </span>
                            </button>
                            <button
                              className="list-group-item list-group-item-action  card-bg-color my-1"
                              onClick={() =>
                                role === "Admin"
                                  ? navigate("/admin/userlogs")
                                  : navigate("/subadmin/userlogs")
                              }
                            >
                              👤{" "}
                              <span className="ms-2 card-text-Color">
                                User Panel Log
                              </span>
                            </button>

                            <button
                              className="list-group-item list-group-item-action  card-bg-color my-1"
                              onClick={() =>
                                role === "Admin"
                                  ? navigate("/admin/api-create-info")
                                  : navigate("/subadmin/api-create-info")
                              }
                            >
                              💻{" "}
                              <span className="ms-2 card-text-Color">
                                API Create Information
                              </span>
                            </button>
                          </div>

                          <DynamicModal
                            open={open}
                            handleClose={() => setOpen(false)}
                            title="Charting Signal"
                          >
                            <div className="row g-4">
                              <div className="d-flex justify-content-center">
                                <ul
                                  className="nav nav-pills shadow p-1"
                                  style={{ padding: "2px" }}
                                >
                                  {chartingSegments.map((segment) => (
                                    <li className="nav-item" key={segment}>
                                      <button
                                        className={`nav-link ${
                                          activeTab === segment ? "active" : ""
                                        }`}
                                        onClick={() => setActiveTab(segment)}
                                        style={{
                                          padding: "4px 10px",
                                          margin: "6px",
                                          fontSize: "1rem",
                                          border: "none",
                                          outline: "none",
                                        }}
                                      >
                                        {segment}
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              </div>

                              <div className="card card-bg-color shadow rounded p-3 d-flex flex-column align-items-center">
                                <div className="mb-3">
                                  <p className="card-text-Color fw-semibold mb-3">
                                    {activeTab}
                                  </p>
                                  <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                                    {/* Label */}
                                    <label className="form-label card-text-Color mb-0">
                                      {activeTab === "Cash" ? "Fund" : "Lot"}
                                    </label>

                                    {/* Input Field */}
                                    <input
                                      type="number"
                                      name="fund"
                                      className="form-control modern-input"
                                      placeholder={`Enter ${
                                        activeTab === "Cash" ? "fund" : "lot"
                                      } amount`}
                                      value={
                                        activeTab === "Cash"
                                          ? formData.fund
                                          : formData.lot
                                      }
                                      onChange={handleChange}
                                      style={{ width: "130px" }}
                                    />

                                    {/* Vertical Arrow Buttons */}
                                    <div className="d-flex flex-column">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary p-1 mb-1"
                                        onClick={handleUp}
                                        title="Increase"
                                      >
                                        <ChevronUp size={18} />
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary p-1"
                                        onClick={handleDown}
                                        title="Decrease"
                                      >
                                        <ChevronDown size={18} />
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                {/* Save Button */}
                                <div className="text-end pt-2">
                                  <button
                                    className="addbtn btn"
                                    onClick={() => handleTypeAction("cash")}
                                  >
                                    Save Changes
                                  </button>
                                </div>
                              </div>
                            </div>
                          </DynamicModal>

                          {/* Logout Button */}
                          <div className="text-center p-3 border-top">
                            <button
                              className="btn btn-danger w-100"
                              onClick={logout}
                            >
                              Log out <i className="ri-login-box-line ms-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {role === "User" && (
                    <div className="iq-sub-dropdown iq-user-dropdown">
                      <div className="iq-card shadow-none m-0">
                        <div className="iq-card-body p-0 ">
                          <div className="bg-primary p-3">
                            <h5 className="text-white-important">{Username}</h5>
                            {/* <span className="text-white-important">online</span> */}
                          </div>
                          <Link
                            to="/user/profile"
                            className="iq-sub-card iq-bg-primary-hover text-decoration-none"
                          >
                            <div className="media align-items-center d-flex">
                              <div className="rounded card-icon bg-soft-primary">
                                <i className="ri-file-user-line" />
                              </div>
                              <div className="media-body ms-3">
                                <h6 className="mb-0 ">My Profile</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="/user/all/transection"
                            className="iq-sub-card iq-bg-primary-hover text-decoration-none"
                          >
                            <div className="media align-items-center d-flex">
                              <div className="rounded card-icon bg-soft-primary">
                                <i class="ri-wallet-line"></i>
                              </div>
                              <div className="media-body ms-3">
                                <h6 className="mb-0 ">My Funds</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="/user/plans"
                            className="iq-sub-card iq-bg-primary-hover text-decoration-none"
                          >
                            <div className="media align-items-center d-flex">
                              <div className="rounded card-icon bg-soft-primary">
                                <i className="ri-file-user-line" />
                              </div>
                              <div className="media-body ms-3">
                                <h6 className="mb-0 ">My Plans</h6>
                              </div>
                            </div>
                          </Link>

                          {Broker == "BAJAJ" ? (
                            ""
                          ) : (
                            <Link
                              className="iq-sub-card iq-bg-warning-hover text-decoration-none"
                              onClick={(e) => handleSetApiKey(e)}
                            >
                              <div className="media align-items-center d-flex">
                                <div className="rounded card-icon bg-soft-warning">
                                  <i className="ri-profile-line" />
                                </div>
                                <div className="media-body ms-3">
                                  <h6 className="mb-0 ">Set API Key</h6>
                                </div>
                              </div>
                            </Link>
                          )}
                          <Link
                            to="/user/editprofile"
                            className="iq-sub-card iq-bg-warning-hover text-decoration-none"
                          >
                            <div className="media align-items-center d-flex">
                              <div className="rounded card-icon bg-soft-warning">
                                <i className="ri-profile-line" />
                              </div>
                              <div className="media-body ms-3">
                                <h6 className="mb-0 ">Change Password</h6>
                              </div>
                            </div>
                          </Link>

                          <Link className="iq-sub-card iq-bg-warning-hover text-decoration-none">
                            <div
                              className="media align-items-center d-flex"
                              onClick={handleBroker}
                            >
                              <div className="rounded card-icon bg-soft-warning">
                                <i className="ri-profile-line" />
                              </div>
                              <div className="media-body ms-3">
                                <h6 className="mb-0 ">API Process</h6>
                              </div>
                            </div>
                          </Link>

                          <div className="d-inline-block w-100 text-center p-3">
                            <button
                              className="addbtn btn iq-sign-btn"
                              onClick={logout}
                              role="button"
                            >
                              Log out
                              <i className="iconcol ri-login-box-line ms-2" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              </ul>
            </div>
            <div className="d-block d-lg-none w-100">
              <div
                className="collapse navbar-collapse "
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav ms-auto navbar-list align-items-center d-flex">
                  {role === "Admin" && (
                    <div className="d-flex justify-content-end align-items-center  btn-width">
                      <button
                        className={`w-100 py-1  shadow-sm btn btn-sm m-2  ${
                          isAutoLogin
                            ? "btn-outline-success"
                            : "btn-outline-danger"
                        }`}
                        onClick={handleAutoLoginbtn}
                        disabled={autoLoginLoading}
                      >
                        {autoLoginLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <strong className="" style={{ fontSize: "0.9rem" }}>
                              Auto Login
                            </strong>
                          </>
                        )}
                      </button>

                      <button
                        className={`w-100 py-1  shadow-sm btn btn-sm m-2  ${
                          isDataStart
                            ? "btn-outline-success"
                            : "btn-outline-danger"
                        }`}
                        onClick={handleDataStart}
                        disabled={dataStartloading}
                      >
                        {dataStartloading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <strong className="" style={{ fontSize: "0.9rem" }}>
                              Data Start
                            </strong>
                          </>
                        )}
                      </button>

                      <div
                        className="nav-item ms-1 btn-text-color"
                        onClick={() => {
                          navigate("/admin/clientactivity");
                        }}
                      >
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="addbtn btn mt-0 btn1 "
                        >
                          <span className="btn-text-color">
                            <span>
                              <Wallet className="iconcol" />
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                  {role === "User" && (
                    <>
                      {getBrokerName && getBrokerName == "Demo" && (
                        <li className="nav-item">
                          <button type="button" className="addbtn btn  btn1">
                            Demo Account
                          </button>
                        </li>
                      )}

                      <li className="nav-item d-flex  ">
                        <li className="live-price-item ">
                          <div className="live-price-box">
                            <span className="label card-text-Color">
                              NIFTY:
                            </span>
                            <span
                              className="LivePrice_NIFTY liveprice-text-color ms-1"
                              ref={niftyRef}
                            >
                              {}
                            </span>
                          </div>
                        </li>
                        <li className="live-price-item ">
                          <div className="live-price-box">
                            <span className="label card-text-Color">
                              BANKNIFTY:
                            </span>
                            <span
                              className="LivePrice_BANKNIFTY liveprice-text-color ms-1"
                              ref={bankNiftyRef}
                            >
                              {}
                            </span>
                          </div>
                        </li>

                        <li className="live-price-item">
                          <div className="live-price-box">
                            <span className="label card-text-Color">
                              FINNIFTY:
                            </span>
                            <span className="LivePrice_FINNIFTY liveprice-text-color ms-1">
                              {}
                            </span>
                          </div>
                        </li>
                      </li>
                    </>
                  )}

                  <li
                    className={`nav-item d-none ${
                      activeElement === "profile" ? "iq-show" : ""
                    }`}
                  >
                    <a
                      href="#"
                      className={`text-decoration-none search-toggle d-flex align-items-center iq-waves-effectt ${
                        activeElement === "profile" ? "active" : ""
                      }`}
                      onClick={(e) => handleClick(e, "profile")}
                    >
                      <img
                        src={selectedImage || "/assets/images/user/demo.jpg"}
                        className="img-fluid rounded-circle me-3 border border-2 border-primary"
                        alt="user"
                      />
                      <div className="caption text-start">
                        <h6 className="mb-0 fw-semibold card-text-Color">
                          {Username}
                        </h6>
                      </div>
                    </a>

                    {role != "User" && (
                      <div className="iq-sub-dropdown iq-user-dropdown">
                        <div className="card shadow border-0">
                          <div className="card-body p-0">
                            <div className="bg-primary p-3 rounded-top">
                              <h5 className="text-white mb-0 card-text-Color">
                                {Username}
                              </h5>
                            </div>

                            <div
                              className="list-group list-group-flush ps-2"
                              style={{
                                maxHeight: "400px",
                                overflowY: "auto",
                                overflowX: "hidden",
                              }}
                            >
                              {role === "Admin" && (
                                <>
                                  <button
                                    className="list-group-item list-group-item-action  ms-2 card-bg-color"
                                    onClick={() =>
                                      Broker == "BAJAJ"
                                        ? ""
                                        : setIsModalVisible(true)
                                    }
                                  >
                                    🔐{" "}
                                    <span className="ms-2 card-text-Color">
                                      Set API Key
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() => setShowModal(true)}
                                  >
                                    🔑{" "}
                                    <span className="ms-2 card-text-Color">
                                      Auto Login
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() => navigate("/admin/Coupon")}
                                  >
                                    🎟️{" "}
                                    <span className="ms-2 card-text-Color">
                                      Coupons
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() =>
                                      navigate("/admin/ResponseQnA")
                                    }
                                  >
                                    📬{" "}
                                    <span className="ms-2 card-text-Color">
                                      Respond to Queries
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() =>
                                      navigate("/admin/Master-Account")
                                    }
                                  >
                                    👑{" "}
                                    <span className="ms-2 card-text-Color">
                                      Master Account
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() => setOpen(true)}
                                  >
                                    📡{" "}
                                    <span className="ms-2 card-text-Color">
                                      Admin Signal
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() =>
                                      navigate("/admin/clientreport")
                                    }
                                  >
                                    📑{" "}
                                    <span className="ms-2 card-text-Color">
                                      Client Thread Report
                                    </span>
                                  </button>

                                  <button
                                    className="list-group-item list-group-item-action  card-bg-color my-1"
                                    onClick={() => navigate("/admin/smtp")}
                                  >
                                    ⚙️{" "}
                                    <span className="ms-2 card-text-Color">
                                      System & SMTP Details
                                    </span>
                                  </button>
                                </>
                              )}
                              <button
                                className="list-group-item list-group-item-action  card-bg-color my-1"
                                onClick={() =>
                                  role == "Admin"
                                    ? navigate("/admin/servicereport")
                                    : navigate("/subadmin/servicereport")
                                }
                              >
                                🛠️{" "}
                                <span className="ms-2 card-text-Color">
                                  Service Report
                                </span>
                              </button>
                              <button
                                className="list-group-item list-group-item-action  card-bg-color my-1"
                                onClick={() =>
                                  role === "Admin"
                                    ? navigate("/admin/userlogs")
                                    : navigate("/subadmin/userlogs")
                                }
                              >
                                👤{" "}
                                <span className="ms-2 card-text-Color">
                                  User Panel Log
                                </span>
                              </button>

                              <button
                                className="list-group-item list-group-item-action  card-bg-color my-1"
                                onClick={() =>
                                  role === "Admin"
                                    ? navigate("/admin/transectionrequest")
                                    : navigate("/subadmin/transaction-history")
                                }
                              >
                                💵{" "}
                                <span className="ms-2 card-text-Color">
                                  Transaction Requests
                                </span>
                              </button>

                              <button
                                className="list-group-item list-group-item-action  card-bg-color my-1"
                                onClick={() =>
                                  role === "Admin"
                                    ? navigate("/admin/api-create-info")
                                    : navigate("/subadmin/api-create-info")
                                }
                              >
                                💻{" "}
                                <span className="ms-2 card-text-Color">
                                  API Create Information
                                </span>
                              </button>
                            </div>

                            <DynamicModal
                              open={open}
                              handleClose={() => setOpen(false)}
                              title="Charting Signal"
                            >
                              <div className="row g-4">
                                <div className="d-flex justify-content-center">
                                  <ul
                                    className="nav nav-pills shadow p-1"
                                    style={{ padding: "2px" }}
                                  >
                                    {chartingSegments.map((segment) => (
                                      <li className="nav-item" key={segment}>
                                        <button
                                          className={`nav-link ${
                                            activeTab === segment
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() => setActiveTab(segment)}
                                          style={{
                                            padding: "4px 10px",
                                            margin: "6px",
                                            fontSize: "1rem",
                                            border: "none",
                                            outline: "none",
                                          }}
                                        >
                                          {segment}
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                </div>

                                <div className="card card-bg-color shadow rounded p-3 d-flex flex-column align-items-center">
                                  <div className="mb-3">
                                    <p className="card-text-Color fw-semibold mb-3">
                                      {activeTab}
                                    </p>
                                    <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                                      <label className="form-label card-text-Color mb-0">
                                        {activeTab === "Cash" ? "Fund" : "Lot"}
                                      </label>

                                      <input
                                        type="number"
                                        name="fund"
                                        className="form-control modern-input"
                                        placeholder={`Enter ${
                                          activeTab === "Cash" ? "fund" : "lot"
                                        } amount`}
                                        value={
                                          activeTab === "Cash"
                                            ? formData.fund
                                            : formData.lot
                                        }
                                        onChange={handleChange}
                                        style={{ width: "130px" }}
                                      />

                                      <div className="d-flex flex-column">
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary p-1 mb-1"
                                          onClick={handleUp}
                                          title="Increase"
                                        >
                                          <ChevronUp size={18} />
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary p-1"
                                          onClick={handleDown}
                                          title="Decrease"
                                        >
                                          <ChevronDown size={18} />
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-end pt-2">
                                    <button
                                      className="addbtn btn"
                                      onClick={() => handleTypeAction("cash")}
                                    >
                                      Save Changes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </DynamicModal>

                            <div className="text-center p-3 border-top">
                              <button
                                className="btn btn-danger w-100"
                                onClick={logout}
                              >
                                Log out{" "}
                                <i className="ri-login-box-line ms-2"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {role === "User" && (
                      <div className="iq-sub-dropdown iq-user-dropdown">
                        <div className="iq-card shadow-none m-0">
                          <div className="iq-card-body p-0 ">
                            <div className="bg-primary p-3">
                              <h5 className="text-white-important">
                                {Username}
                              </h5>
                              {/* <span className="text-white-important">online</span> */}
                            </div>
                            <Link
                              to="/user/profile"
                              className="iq-sub-card iq-bg-primary-hover text-decoration-none"
                            >
                              <div className="media align-items-center d-flex">
                                <div className="rounded card-icon bg-soft-primary">
                                  <i className="ri-file-user-line" />
                                </div>
                                <div className="media-body ms-3">
                                  <h6 className="mb-0 ">My Profile</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="/user/all/transection"
                              className="iq-sub-card iq-bg-primary-hover text-decoration-none"
                            >
                              <div className="media align-items-center d-flex">
                                <div className="rounded card-icon bg-soft-primary">
                                  <i class="ri-wallet-line"></i>
                                </div>
                                <div className="media-body ms-3">
                                  <h6 className="mb-0 ">My Funds</h6>
                                </div>
                              </div>
                            </Link>
                            <Link
                              to="/user/plans"
                              className="iq-sub-card iq-bg-primary-hover text-decoration-none"
                            >
                              <div className="media align-items-center d-flex">
                                <div className="rounded card-icon bg-soft-primary">
                                  <i className="ri-file-user-line" />
                                </div>
                                <div className="media-body ms-3">
                                  <h6 className="mb-0 ">My Plans</h6>
                                </div>
                              </div>
                            </Link>

                            {Broker == "BAJAJ" ? (
                              ""
                            ) : (
                              <Link
                                className="iq-sub-card iq-bg-warning-hover text-decoration-none"
                                onClick={(e) => handleSetApiKey(e)}
                              >
                                <div className="media align-items-center d-flex">
                                  <div className="rounded card-icon bg-soft-warning">
                                    <i className="ri-profile-line" />
                                  </div>
                                  <div className="media-body ms-3">
                                    <h6 className="mb-0 ">Set API Key</h6>
                                  </div>
                                </div>
                              </Link>
                            )}
                            <Link
                              to="/user/editprofile"
                              className="iq-sub-card iq-bg-warning-hover text-decoration-none"
                            >
                              <div className="media align-items-center d-flex">
                                <div className="rounded card-icon bg-soft-warning">
                                  <i className="ri-profile-line" />
                                </div>
                                <div className="media-body ms-3">
                                  <h6 className="mb-0 ">Change Password</h6>
                                </div>
                              </div>
                            </Link>

                            <Link className="iq-sub-card iq-bg-warning-hover text-decoration-none">
                              <div
                                className="media align-items-center d-flex"
                                onClick={handleBroker}
                              >
                                <div className="rounded card-icon bg-soft-warning">
                                  <i className="ri-profile-line" />
                                </div>
                                <div className="media-body ms-3">
                                  <h6 className="mb-0 ">API Process</h6>
                                </div>
                              </div>
                            </Link>

                            <div className="d-inline-block w-100 text-center p-3">
                              <button
                                className="addbtn btn iq-sign-btn"
                                onClick={logout}
                                role="button"
                              >
                                Log out
                                <i className="iconcol ri-login-box-line ms-2" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {showModal && (
        <div
          className="modal show"
          id="exampleModal"
          style={{ display: "block" }}
        >
          <div
            className="modal fade"
            id="exampleModalCenter"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          ></div>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div className="modal-header card-bg-color">
                <h5
                  className="modal-title card-text-Color"
                  id="exampleModalLabel"
                >
                  🔑 Auto Login
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <div className="d-flex flex-column align-items-center gap-3">
                  {/* Auto Login Button */}
                  <button
                    className="addbtn btn w-75 py-2 shadow-sm btn btn-outline-primary"
                    onClick={handleAutoLoginbtn}
                    disabled={autoLoginLoading}
                  >
                    {autoLoginLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Processing...
                      </>
                    ) : (
                      <>
                        🔑{" "}
                        <strong className="btn-text-color">Auto Login</strong>
                      </>
                    )}
                  </button>

                  {/* Data Start Button */}
                  <button
                    className="addbtn btn w-75 py-2 shadow-sm btn btn-outline-success"
                    onClick={handleDataStart}
                    disabled={dataStartloading}
                  >
                    {dataStartloading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Processing...
                      </>
                    ) : (
                      <>
                        🚀{" "}
                        <strong className="btn-text-color">Data Start</strong>
                      </>
                    )}
                  </button>

                  {/* Last Pattern Button */}
                  <button
                    className="addbtn btn w-75 py-2 shadow-sm btn btn-outline-warning"
                    onClick={handleLastPattern}
                    disabled={lastPatternloading}
                  >
                    {lastPatternloading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Processing...
                      </>
                    ) : (
                      <>
                        🔍{" "}
                        <strong className="btn-text-color">Last Pattern</strong>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Broker Modal */}
      {showAddBrokerModal && (
        <div
          className="modal show"
          id="exampleModal"
          style={{ display: "block" }}
        >
          <div
            className="modal fade"
            id="exampleModalCenter"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          ></div>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add Broker
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setAddBrokerName("");
                    setShowAddBrokerModal(false);
                  }}
                />
              </div>
              <div>
                <div className="mx-4">
                  <label className="mt-4">Broker Name</label>
                  <input
                    type="text"
                    className="form-control mb-4"
                    placeholder="Enter Broker Name"
                    onChange={(e) => setAddBrokerName(e.target.value)}
                    value={addBrokerName}
                  />
                </div>
                <div className="d-flex justify-content-end mb-4 mx-4">
                  <button className="addbtn btn" onClick={handleAddBroker}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Update Broker Key Modal */}
      <UpdateBrokerKey
        isVisible={isModalVisible}
        closeModal={handleCloseModal}
        Role={role}
      />

      {/* API Steps Modal */}
      {showApiStepsModal && (
        <ApiProcessModal
          brokerName={Broker}
          show={showApiStepsModal}
          onClose={() => setShowApiStepsModal(false)}
        />
      )}
    </>
  );
};

export default Header;
